import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export class AvatarBaseComponent {
  @Input() initials = '';
  @Input() profileButton = false;
  @Output() tapped = new EventEmitter();
}
